const computeInternally = ({data, computations, computationUpdates}) => {
  if (!computations || !computations.length) {
    return computationUpdates;
  }
  let [first, ...restComputations] = computations;
  let {
    computation: {compute},
  } = first;
  let result = compute({data});
  if (result && result instanceof Promise) {
    return result
      .then(_result => {
        if (_result) {
          computationUpdates = computationUpdates || {};
          computationUpdates = {...computationUpdates, ..._result};
          return computeInternally({
            data,
            computations: restComputations,
            computationUpdates,
          });
        }
      })
      .catch(e => {
        throw new Error('Error in computation', e.message);
      });
  } else if (result) {
    computationUpdates = computationUpdates || {};
    computationUpdates = {...computationUpdates, ...result};
  }

  return computeInternally({
    data,
    computations: restComputations,
    computationUpdates,
  });
};

const compute = ({field, data, computations}) => {
  if (!computations || !Object.keys(computations).length) {
    return;
  }

  let computationsToResolve = [];
  for (let key in computations) {
    const {onChange} = computations[key];
    if (onChange && onChange.indexOf(field) >= 0) {
      computationsToResolve.push({key, computation: computations[key]});
    }
  }

  let computedResult = computeInternally({
    data,
    computations: computationsToResolve,
  });

  return computedResult;
};

export {compute};
